module.exports = "<div class=\"container\">\r\n    <app-page-header heading=\"New Case\"></app-page-header>\r\n\r\n\r\n    <div class=\"mt-4\" style=\"margin-top:20px\">\r\n        <button [disabled]=\"checkInvalid()\" (click)=\"createMember()\" mat-raised-button color=\"primary\">Create New Member</button>\r\n    </div>\r\n\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/cases-management/new-case/new-case.component.html
// module id = 605
// module chunks = 0